import {GraphQlSchema} from "../../../types/GraphQlSchema";
import {SearchObjectsModel, SearchPropertyModel} from "../../../types/Search";

const ENUM_TYPE_NAME = /(?<=(?=[^_]+$))(.*)(?=Fields)/;
const ALL_FIELDS_SUFFIX = 'AllFields';
const OBJECT_AGGREGATION_TYPE = 'object';

/**
 * Utility class for common logic used in the search page and components.
 */
export default class SearchUtils {

  /**
   * Builds model which will be used from the search page components. The model consists in all searchable objects and
   * their properties and it is based of the GQL schema introspection for Search Service.
   *
   * @param {GraphQlSchema} searchGraphQlSchema the schema object build from the GQL service introspection
   * @returns {SearchObjectsModel} model
   */
  static buildSearchObjectsModel(searchGraphQlSchema: GraphQlSchema): SearchObjectsModel {
    const objectsMap = new Map<string, Array<SearchPropertyModel>>();
    searchGraphQlSchema.objectTypes.forEach((value, objectName) => {
      const properties = this.processObjectEnums(searchGraphQlSchema, objectName);
      if (properties && properties.length) {
        objectsMap.set(objectName, properties);
      }
    });
    return {objectsMap};
  }

  private static processObjectEnums(searchGraphQlSchema: GraphQlSchema, objectName: string): Array<SearchPropertyModel> {
    const searchProperties: Array<SearchPropertyModel> = [];
    searchGraphQlSchema.enums.forEach((gqlEnum, enumName) => {
      // Ignore 'AllFields' enums as we don't need them here
      // TODO do we support names like 'ObjectName_ObjectName_something' if so the parsing will break here
      if (enumName.indexOf(ALL_FIELDS_SUFFIX) === -1 && enumName.startsWith(`${objectName}_`)) {
        const aggregationType = ENUM_TYPE_NAME.exec(enumName)?.pop();
        if (aggregationType) {
          const aggregation = aggregationType.toLowerCase();
          gqlEnum.values.forEach(propertyName => searchProperties.push({
            name: propertyName,
            aggregationType: aggregation,
            isObject: aggregation === OBJECT_AGGREGATION_TYPE,
            range: searchGraphQlSchema.objectTypes.get(objectName)?.fieldsMap.get(propertyName)?.range || ''
          }));
        }
      }
    })
    return searchProperties;
  }
}
